"use client"

import { type Locale } from "date-fns/locale"
import { useTolgee } from "@tolgee/react"
import { getDateLocale } from "./date-locale"

/** 客户端 hook：从 Tolgee 获取当前 locale 并返回对应的 date-fns locale */
export function useDateLocale(): Locale {
  const tolgee = useTolgee(["language"])
  const locale = tolgee.getLanguage() ?? "en"
  return getDateLocale(locale)
}
